import React from 'react'

const Dashboard = () => {
  return (
    <div>
      adfadfd
    </div>
  )
}

export default Dashboard
